import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable, share } from 'rxjs';
import { User } from '../../data/model/user';
import { AppActions, AppSelectors } from '../../store/app-store';
import { PasswordResetDialogComponent } from '../password-reset-dialog/password-reset-dialog.component';
import { RegisterTotpDeviceDialogComponent } from '../register-totp-device-dialog/register-totp-device-dialog.component';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-user-menu',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuComponent implements OnInit {
  public user$: Observable<User | null> | undefined;

  constructor(
    private store: Store,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.user$ = this.store.select(AppSelectors.selectUser);
  }

  getUserName(user: User) {
    return user.first_name && user.last_name
      ? `${user.first_name} ${user.last_name}`
      : user.username;
  }

  openResetDialog(user:User) {
    const screenWidth = window.innerWidth;
    let dialogWidth = '30%'; // default

    if (screenWidth < 600) {
      dialogWidth = '100%'; // mobile
    } else if (screenWidth < 1000) {
      dialogWidth = '60%'; // tablet
    }
    this.dialog.open(PasswordResetDialogComponent, {
      width: dialogWidth,
      data: { user: user },
    });
  }

  openRegisterTOTPDialog(user:User) {
    const screenWidth = window.innerWidth;

    // Example breakpoints
    let dialogWidth = '30%'; // default

    if (screenWidth < 600) {
      dialogWidth = '100%'; // mobile
    } else if (screenWidth < 1000) {
      dialogWidth = '60%'; // tablet
    }
    this.dialog.open(RegisterTotpDeviceDialogComponent, {
      width: dialogWidth,
      data: { user: user },
    });
  }

  logOut() {
    this.store.dispatch(AppActions.logOut());
  }
}
